import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getStoreList } from "../../API/OffersApi";
import { ListOfStore } from "../storePage/ListOfStore";
import { useDispatch } from "react-redux";
import { removeEverything } from "../../redux/CartSlice";

export const GymOffer = ({props}) => {
  const { code } = useParams();
  var [data,setData]=useState()
  var [offerDetails,setOfferDetails]=useState()
  const dispatch = useDispatch();

  const getData = () => {
    getStoreList(code)
      .then((data) => {
        // console.log(data);
        setData(data?.data?.data)
        setOfferDetails(data?.data?.offerDetails)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    dispatch(removeEverything({isOffered:true}))
    getData();
  }, []);

  return (
    <>
      <div>GymOffer</div>
      {console.log(data)}
      {data && <ListOfStore data={data} isOffered={true} offerDetails={offerDetails}/>}
    </>
  );
};
